import InlineSpinner from '../Spinner/InlineSpinner';
import React, { Component } from 'react';
import { Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Localized } from '@fluent/react';
import postTranslations from '../../controllers/postTranslation';
import { prettyDate } from '../../tools/date';
import { addData, deleteData, getData } from '../../db';

export default class ReportsRow extends Component {
  static defaultProps = {
    noImage: false,
  };

  state = {
    favoriteLoading: false,
    reportTranslatedText: '',
    reportTranslatedTitle: '',
    reportTranslatedCat: [],
    loadingReport: false,
  };

  renderTLPColor = TLP => {
    return `tlp-${TLP ? TLP.toLowerCase() : ''}`;
  };

  toggleFavorite = () => {
    const { addToFavorite, deleteFromFavorite } = this.props;
    const { favorite, id } = this.props.report;

    this.setState({
      favoriteLoading: true,
    });

    if (!favorite) {
      addToFavorite(id)
        .then(() => this.setState({ favoriteLoading: false }))
        .catch(() => this.setState({ favoriteLoading: false }));
    } else {
      deleteFromFavorite(id).then(() =>
        this.setState({ favoriteLoading: false })
      );
    }
  };

  async componentDidMount() {
    const { report } = this.props;
    const lang = localStorage.getItem('language').split('-')[0];
    const reportToTranslate = {
      title: report.title.rendered,
      text: report.excerpt.rendered,
      categories: report?.echo_report_cat?.map(item => item.name),
    };
    if (lang !== 'it') {
      const dataReport = await getData('reports');
      if (dataReport) {
        const currentReport = dataReport.find(
          rp => rp.data.idReport === report.id
        );
        if (currentReport) {
          this.setState({
            reportTranslatedTitle: currentReport?.data.translation.title,
          });
          this.setState({
            reportTranslatedText: currentReport?.data.translation.text,
          });
          this.setState({
            reportTranslatedCat:
              currentReport?.data.translation.categories.split(','),
          });
        }
      }
      const checkData = dataReport.find(rp => rp.data.idReport === report.id);
      const checkDataByDate = checkData?.dateReport === report.date;
      if (!checkData || checkDataByDate) {
        this.setState({ loadingReport: true });
        postTranslations(
          {
            title: reportToTranslate.title,
            text: reportToTranslate.text,
            categories: `${reportToTranslate.categories}`,
          },
          lang
        ).then(async res => {
          if (
            !res ||
            (res && res?.ok === false) ||
            (res && res?.status >= 400 && res?.status < 600)
          ) {
            this.setState({
              reportTranslatedTitle: reportToTranslate.title,
            });
            this.setState({
              reportTranslatedText: reportToTranslate.text,
            });
            this.setState({
              reportTranslatedCat: reportToTranslate.categories,
            });
            this.setState({ loadingReport: false });
          } else {
            this.setState({
              reportTranslatedTitle: res?.translation?.title,
            });
            this.setState({
              reportTranslatedText: res?.translation?.text,
            });
            this.setState({
              reportTranslatedCat: res?.translation?.categories.split(','),
            });
            if (dataReport) {
              const checkData = dataReport.find(
                rp => rp.data.idReport === report.id
              );
              const checkDataByDate = dataReport.find(
                rp =>
                  rp.data.idReport === report.id &&
                  rp.data.dateReport !== report.date
              );
              if (!checkData) {
                addData(
                  { ...res, idReport: report.id, dateReport: report.date },
                  'reports'
                );
              } else if (checkDataByDate) {
                deleteData(checkDataByDate.id, 'reports');
                addData(
                  { ...res, idReport: report.id, dateReport: report.date },
                  'reports'
                );
              }
            }
            this.setState({ loadingReport: false });
          }
        });
      }
    }
  }

  render() {
    const { odd, report, noImage } = this.props;
    const { favoriteLoading, loadingReport } = this.state;
    const { favorite, date, id, tlp, echo_report_cat } = report;
    const TLP = tlp && tlp.length ? tlp[0].name : false;
    const lang = localStorage.getItem('language').split('-')[0];
    const { reportTranslatedText, reportTranslatedTitle, reportTranslatedCat } =
      this.state;

    return (
      <li className={`row report-item media ${odd ? 'my-4' : ''}`}>
        {!noImage && (
          <Col className="col-12" xl={3} lg={3}>
            <Localized id="default_img_placeholder" attrs={{ alt: true }}>
              <img
                className="report-cover-img img-fluid"
                src={report.featured_image || '/img/img-placeholder.jpg'}
                alt="default_img_placeholder"
              />
            </Localized>
          </Col>
        )}
        <Col className="col-12" xl={9} lg={9}>
          <div className="media-body">
            <div className="row justify-content-between">
              <div className="col-10 mb-1 report-list-title">
                <Link to={`/report/${id}`}>
                  <h3
                    className="report-title"
                    dangerouslySetInnerHTML={{
                      __html:
                        lang === 'it' || loadingReport
                          ? report.title.rendered
                          : reportTranslatedTitle,
                    }}
                  />
                </Link>
              </div>
              <div className="col-1">
                {favoriteLoading ? (
                  <InlineSpinner width={24} height={24} />
                ) : !favorite ? (
                  <Localized id="favorites_add_to" attrs={{ title: true }}>
                    <i
                      className={`fa fa-star${favorite ? '' : '-o'} fa-lg`}
                      onClick={this.toggleFavorite}
                      title="favorites_add_to"
                    />
                  </Localized>
                ) : (
                  <Localized id="favorites_remove_from" attrs={{ title: true }}>
                    <i
                      className={`fa fa-star${favorite ? '' : '-o'} fa-lg`}
                      onClick={this.toggleFavorite}
                      title="favorites_remove_from"
                    />
                  </Localized>
                )}
              </div>
            </div>
            <div className="report-tags">
              {(echo_report_cat || []).map((tag, i) => (
                <span key={tag.id} className="badge report-tag">
                  {lang === 'it' || loadingReport
                    ? tag.name
                    : reportTranslatedCat?.[i]}
                </span>
              ))}
            </div>
            <div
              className="report-excerpt"
              dangerouslySetInnerHTML={{
                __html:
                  lang === 'it' || loadingReport
                    ? report.excerpt.rendered
                    : reportTranslatedText,
              }}
            />
            <div className={`badge mr-1 ${this.renderTLPColor(TLP)}`}>
              TLP:{TLP.toUpperCase()}
            </div>
            <span className="date-label small">
              {prettyDate(new Date(date))}
            </span>
          </div>
        </Col>
        {loadingReport && <p className="loader">translating...</p>}
      </li>
    );
  }
}
